import { TableCell, Table, TableRow, TableHead, TableBody, TableContainer, Paper, Tooltip, Button, Typography } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, } from "@mui/icons-material";
import { DeletePopUp, NoRecordFound, PageLoader, STableLoader } from '../../../../shared_elements';
import moment from 'moment';
import { backendDateFormat, displayDateFormatShort } from '../../../../constants';
import { trackActivity } from '../../../../utils/mixpanel';
import HolidayCru from './HolidayCru';
import { useEffect, useRef, useState } from 'react';
import { calenderFileImport, calenderSampleFile, deleteHolidayListApi, getHolidayListApi } from '../apiService';
import { globalDeleteService, globalExportService, globalGetService, globalPostService } from '../../../../utils/globalApiServices';
import { checkApiStatus, downloadFileType } from '../../../../utils';
import { useSnackbar } from 'notistack';
import HolidayListing from './HolidayListing';
import { PermissionWrapper } from '../../../../wrappers';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const Holiday = ({ calenderSlug, calenderDetail }) => {
    const fileInputRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [deleteHolidayList, setDeleteHolidayList] = useState({ modal: false, data: null, })
    const [holidayListCRU, setHolidayListCRU] = useState({ modal: false, data: null, mode: '' });
    const [holidayList, setHolidayList] = useState({});

    useEffect(() => {
        if(calenderSlug) {getHolidayList('skeletonLoader', { per_page: 50 })}
        trackActivity('Page Viewed', { page_title: 'Calendar' })
    }, [calenderSlug])
    
    const getHolidayList = async (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        try {
            const response = await globalGetService(getHolidayListApi({ calenderSlug, ...query }));
            if (checkApiStatus(response)) {
                setHolidayList(response?.data?.data || {});
            }
        } finally {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        }
    };

    const deleteholidayListFn = () => {
        setLoading(true);
        globalDeleteService(deleteHolidayListApi({ calenderSlug }), { ids: [deleteHolidayList?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Holiday List`, success_msg: response?.data?.message, item_ids: deleteHolidayList?.data, response: response?.data })
                    setDeleteHolidayList({ modal: false, data: null });
                    getHolidayList('', { per_page: holidayList?.pagination?.per_page });
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Holiday List`, error_msg: response?.data?.message, item_ids: deleteHolidayList?.data, response: response?.data })
                }
            })
    }

    const handleImportClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        event.target.value = null;

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        try {
            const response = await globalPostService(
                calenderFileImport({ calenderSlug }),
                formData
            );

            if (!checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data?.message || "File import failed",
                    { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } }
                );
                return;
            }

            const fileData = response?.data?.data;

            if (!Array.isArray(fileData)) {
                enqueueSnackbar(response?.data?.message, { variant: "success" });
                await getHolidayList();
                return;
            }

            if (!fileData.length) {
                enqueueSnackbar("File is empty. Please upload valid holiday list.", { variant: "error" });
                return;
            }

            const expectedKeys = ["name", "date", "notes"];
            const actualKeys = Object.keys(fileData[0]).map((k) => k.toLowerCase().trim());
            const hasAllExpectedKeys = expectedKeys.every((key) => actualKeys.includes(key));

            if (!hasAllExpectedKeys) {
                enqueueSnackbar("Invalid file format. Required columns: Name, Date, Notes.", { variant: "error" });
                return;
            }

            enqueueSnackbar(response?.data?.message, { variant: "success" });
            await getHolidayList();

        } catch (err) {
            const message = err?.response?.data?.message || err?.message || "Something went wrong while importing file";
            enqueueSnackbar(message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
        } finally {
            setLoading(false);
        }
    };

    const downlodSampleFile = () => {
        setLoading(true);
        globalExportService(calenderSampleFile({ calenderSlug }))
            .then((response) => {
                downloadFileType(response?.data, `holiday_list_sample_${moment().format(backendDateFormat)}.`, "xlsx");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Holiday List`, page_type: page_type, })
    }
    return (
        <TableContainer className="lease-detail-table">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 style={{ fontSize: '14px', fontWeight: '600' }}>Holiday's List</h2>
                <div >
                    <Typography variant="body2" onClick={() => { downlodSampleFile(); handleItemClicked('Download Sample File') }} sx={{ cursor: "pointer", color: "blue", textDecoration: "underline", fontSize: "12px", fontWeight: "normal", display: "inline", mr: 1 }} component="span" > Download Sample File </Typography>
                    <Button size="small" variant="outlined" className='btn-primary' sx={{ mr: 1 }} onClick={() => { handleImportClick(); handleItemClicked('Import Button') }}> IMPORT </Button>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calender", operationType: ['C'] }}>
                        <Button variant="contained" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setHolidayListCRU({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Holiday List</Button>
                    </PermissionWrapper>
                </div>
            </div>
            <input type="file" accept=".xlsx" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
            <div style={holidayList?.list?.length > 0 ? { overflow: "auto", height: "320px" } : { overflow: "auto", height: "auto", maxHeight: "320px" }}>
                {skeletonLoader ? <STableLoader count={4} rowCount={6} /> : (<>
                    <Table className="mui-table-format" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{minWidth: "100px"}}>Name</TableCell>
                                <TableCell sx={{minWidth: "100px"}}>Date</TableCell>
                                <TableCell sx={{maxWidth: '100px'}}>Notes</TableCell>
                                <TableCell sx={{ textAlign: "right" }}>
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calender", operationType: ['C'] }}>
                                        Action(s)
                                    </PermissionWrapper>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {holidayList?.list?.length > 0 && holidayList?.list?.map((item) => {
                                return (
                                    <HolidayListing
                                            key={item?.id}
                                            item={item}
                                            onEditFn={() => setHolidayListCRU({ modal: true, data: item, mode: 'edit' })}
                                            ondeleteCalenderFn={() => setDeleteHolidayList({ modal: true, data: item, })}                
                                        />
                                );
                            })}
                        </TableBody>
                    </Table>
                </>)}
                {!skeletonLoader && holidayList?.list?.length === 0 && <NoRecordFound />}
            </div>
            {holidayListCRU.modal &&
                <HolidayCru
                    holidayListCRU={holidayListCRU}
                    modeType={holidayListCRU?.mode}
                    calenderSlug={calenderSlug}
                    calenderDetail={calenderDetail}
                    getResponseBack={() => getHolidayList("", { per_page: holidayList?.pagination?.per_page })}
                    onToggleModal={() => setHolidayListCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {deleteHolidayList.modal ?
                <DeletePopUp
                    modal={deleteHolidayList.modal}
                    title={'Delete Holiday List'}
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteHolidayList({ modal: false, data: null })}
                    onDeleteRecords={() => deleteholidayListFn()}
                /> : null}
            {isLoading ? <PageLoader /> : null}
        </TableContainer>
    )
}

export default Holiday
